export enum RecurringDonation {
  RECURRING = 1,
  NON_RECURRING = 0,
}

export enum ShareType {
  STANDARD,
  CUSTOM,
}

export enum PaymentMethod {
  BANK = 2,
  PAYPAL = 3,
  VIPPS_KID = 4,
  BANK_UKID = 5,
  VIPPS = 6,
  BITCOIN = 8,
}
